/**
 * Live workspace-slug preview for the signup form.
 *
 * Mirrors the algorithm in `packages/auth/src/server/core/slug.ts` so the
 * `<SlugPreview>` next to the org-name input shows what the server will
 * almost certainly produce. The server still has final authority (it may
 * append `-2`/`-3` to resolve collisions) — the preview is intentionally
 * called "preview", not "confirmation". An exact-shape match would mean
 * leaking the reserved-slug list to the browser, which isn't worth it for
 * a hint.
 *
 * Returns `null` for inputs that wouldn't produce a valid slug (no
 * alphanumeric content, or shorter than 3 chars after normalisation) so
 * the component can hide the preview cleanly.
 */

const SLUG_MIN = 3;
const SLUG_MAX = 32;

export function previewSlug(orgName: string): string | null {
  const base = orgName
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, SLUG_MAX);
  if (base.length < SLUG_MIN) return null;
  return base;
}
